<template>
    <div class="sidebar">
        <div class="sidebar__head">
          <div class="sidebar__head--button mb-4" v-if="$can('read', 'account_representative') && isMutuaidecommercial">
            <router-link :to="'/assistances-souscrites'">ESPACE RESEAU</router-link>
          </div>
          <div class="sidebar__head--button mb-4" v-else-if="$can('read', 'account_representative')">
                <router-link :to="'/'">ESPACE RESEAU</router-link>
            </div>
            <div class="sidebar__head--button mb-4" v-else-if="$can('be', 'broker')">
              <router-link :to="'/'">ESPACE INTERMEDIAIRE</router-link>
            </div>
            <div class="sidebar__head--button mb-4" v-else-if="$can('be', 'garden')">
              <router-link :to="'/'">ESPACE JARDINERIE</router-link>
            </div>
          <div class="sidebar__head--button mb-4" v-else-if="$can('be', 'mutuaide')">
            <router-link :to="'/'">ESPACE INTERMEDIAIRE</router-link>
          </div>
          <div class="sidebar__head--button mb-4" v-else-if="isSarrut || isSarrutAdmin || isSaga || isSagaAdmin">
            <router-link :to="'/'">ESPACE CABINET COURTAGE</router-link>
          </div>
          <div class="sidebar__head--button mb-4" v-else-if="isLeMondeCampingCar">
            <router-link :to="'/'">ESPACE PARTENAIRE</router-link>
          </div>
            <div class="sidebar__head--button mb-4" v-else>
                <router-link :to="'/'">ESPACE GARAGISTE</router-link>
            </div>
          <div class="sidebar__head--title" v-if="$can('read', 'account_representative') && isMutuaidecommercial">
            <router-link :to="'/assistances-souscrites'">TABLEAU DE BORD</router-link>
          </div>
          <div class="sidebar__head--title" v-else>
              <router-link :to="'/'">TABLEAU DE BORD</router-link>
            </div>
        </div>
        <div class="sidebar__body">
          <template v-if="$can('read', 'account_representative') && isGUEMASrepresentative">
            <div class="sidebar__body__menu-name" >Garanties</div>
            <ul class="sidebar__body__menu mb-3">
              <li class="sidebar__body__menu--item" v-for="item in menuItems">
                <i class="fa fa-chevron-right"></i>
                <router-link class="link-with-bg" :class="{'active-tab' : activeTab === item.name}" :to="item.url">{{item.name}}</router-link>
              </li>
            </ul>
          </template>
          <template v-else-if="$can('read', 'account_representative') && (isSarrutAdmin || isSagaAdmin)">
            <div class="sidebar__body__menu-name">Nouvelle garantie</div>
            <ul class="sidebar__body__menu mb-3">
              <li class="sidebar__body__menu--item" v-for="item in menuItems">
                <template v-if="item.name == 'Assurance Temporaire'">
                  <template v-if="item.style && item.style == 'disabled'">
                    <i class="fa fa-chevron-right" style="color: gray;"></i>
                    <router-link class="link-with-bg" :class="{'active-tab' : activeTab === item.name}" :to="item.url"  style="color: gray; cursor: default; pointer-events: none !important;">Nouveau : {{item.name}}</router-link>
                  </template>
                  <template v-else>
                    <i class="fa fa-chevron-right"></i>
                    <router-link class="link-with-bg" :class="{'active-tab' : activeTab === item.name}" :to="item.url"><span style="color:#ff0000;">Nouveau : </span>{{item.name}}</router-link>
                  </template>
                </template>
                <template v-else>
                  <template v-if="item.style && item.style == 'disabled'">
                    <i class="fa fa-chevron-right" style="color: gray;"></i>
                    <router-link class="link-with-bg" :class="{'active-tab' : activeTab === item.name}" :to="item.url" style="color: gray; cursor: default; pointer-events: none !important;">{{item.name}}</router-link>
                  </template>
                  <template v-else>
                    <i class="fa fa-chevron-right"></i>
                    <router-link class="link-with-bg" :class="{'active-tab' : activeTab === item.name}" :to="item.url">{{item.name}}</router-link>
                  </template>
              </li>
            </ul>
          </template>
          <template v-else-if="$can('read', 'account_representative')"></template>
          <template v-else-if="$can('be', 'broker')">
            <div class="sidebar__body__menu-name" v-else>Nouvelle garantie</div>
            <ul class="sidebar__body__menu mb-3" style="padding: 5px 0px 5px 5px;">
              <li class="sidebar__body__menu--item" v-for="item in menuItems" style="font-size: 12px;">
                <i class="fa fa-chevron-right"></i>
                  <router-link class="link-with-bg" :class="{'active-tab' : activeTab === item.name}" :to="item.url">{{item.name}}</router-link>
              </li>
            </ul>
          </template>
          <template v-else>
            <div class="sidebar__body__menu-name" v-if="$can('read', 'account_representative') && isGUEMASrepresentative">Garanties</div>
            <div class="sidebar__body__menu-name" v-else>Nouvelle garantie</div>
            <ul class="sidebar__body__menu mb-3">
              <li class="sidebar__body__menu--item" v-for="item in menuItems">
                <template v-if="item.name == 'Assurance Temporaire'">
                  <template v-if="item.style && item.style == 'disabled'">
                    <i class="fa fa-chevron-right" style="color: gray;"></i>
                    <router-link class="link-with-bg" :class="{'active-tab' : activeTab === item.name}" :to="item.url"  style="color: gray; cursor: default; pointer-events: none !important;">Nouveau : {{item.name}}</router-link>
                  </template>
                  <template v-else>
                  <i class="fa fa-chevron-right"></i>
                    <router-link class="link-with-bg" :class="{'active-tab' : activeTab === item.name}" :to="item.url"><span style="color:#ff0000;">Nouveau : </span>{{item.name}}</router-link>
                  </template>
                </template>
                <template v-else>
                  <template v-if="item.style && item.style == 'disabled'">
                    <i class="fa fa-chevron-right" style="color: gray;"></i>
                    <router-link class="link-with-bg" :class="{'active-tab' : activeTab === item.name}" :to="item.url" style="color: gray; cursor: default; pointer-events: none !important;">{{item.name}}</router-link>
                  </template>
                  <template v-else>
                    <i class="fa fa-chevron-right"></i>
                  <router-link class="link-with-bg" :class="{'active-tab' : activeTab === item.name}" :to="item.url">{{item.name}}</router-link>
                </template>
              </li>
            </ul>
          </template>
            <div class="sidebar__body__menu-name">Recherche</div>
            <ul class="sidebar__body__menu mb-3">
                <li class="sidebar__body__menu--item" v-for="item in recherchePreparedList">
                    <i class="fa fa-chevron-right"></i>
                    <router-link class="link-with-bg" :class="{'active-tab' : activeTab === item.name}" :to="item.url">{{item.name}}</router-link>
                </li>
                <li class="sidebar__body__menu--item" v-if="isMutuaiderepresentative && !isMutuaidecommercial">
                    <i class="fa fa-chevron-right"></i>
                    <a class="link-with-bg" @click="exportParc" style="cursor: pointer;">Export du Parc Actif</a>
                </li>
              <li class="sidebar__body__menu--item" v-if="isMutuaiderepresentative && !isMutuaidecommercial">
                <i class="fa fa-chevron-right"></i>
                <a class="link-with-bg" @click="exportParcComplete" style="cursor: pointer;">Export du Parc Complet</a>
              </li>
            </ul>

            <template v-if="isMutuaiderepresentative || isMutuaidecommercial || isMutuaide">
              <div class="sidebar__body__menu-name">Documentations</div>
              <ul class="sidebar__body__menu mb-3">
                <li class="sidebar__body__menu--item">
                  <i class="fa fa-chevron-right"></i>
                  <router-link class="link-with-bg" to="/documentations">Dispositions Générales</router-link>
                </li>
              </ul>
            </template>

            <div class="sidebar__body__menu-name">Informations</div>
            <ul class="sidebar__body__menu mb-3">
                <li class="sidebar__body__menu--item" v-if="$can('read', 'account_representative') && !isMutuaidecommercial">
                    <i class="fa fa-chevron-right"></i>
                    <router-link class="link-with-bg" to="/my-account-representative">Mon compte</router-link>
                </li>
                <li class="sidebar__body__menu--item" v-else-if="!isMutuaidecommercial">
                    <i class="fa fa-chevron-right"></i>
                    <router-link class="link-with-bg" to="/my-account">Mon compte</router-link>
                </li>
              <li class="sidebar__body__menu--item" v-if="$can('be', 'garden')">
                <i class="fa fa-chevron-right"></i>
                <router-link class="link-with-bg" to="/commissions">Commissions</router-link>
              </li>
              <li class="sidebar__body__menu--item" v-else-if="$can('be', 'broker') || isSarrutAdmin || isSagaAdmin">
                <i class="fa fa-chevron-right"></i>
                <router-link class="link-with-bg" to="/commissions">Bordereaux Commissions</router-link>
              </li>
              <li class="sidebar__body__menu--item" v-else-if="!$can('read', 'account_representative') && !isSarrut && !isSaga">
                    <i class="fa fa-chevron-right"></i>
                    <router-link class="link-with-bg" to="/factures">Factures</router-link>
                </li>
                <li class="sidebar__body__menu--item" v-if="$can('read', 'account_representative')  && !isMutuaidecommercial && !isMutuaiderepresentative">
                    <i class="fa fa-chevron-right"></i>
                  <router-link class="link-with-bg" to="/my-documents">Mes documents</router-link>
                </li>
                <li class="sidebar__body__menu--item">
                    <i class="fa fa-chevron-right"></i>
                    <a href="#" class="link-logout link-with-bg" @click="$root.logOut">Deconnexion</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Sidebar',
        data() {
            return {
                mechanicItems: [
                    {name: 'Garantie VP - VU - 4x4', url: '/garantie-auto'},
                    {name: 'Garantie Camping Car', url: '/garantie-camping-car'},
                    {name: 'Garantie Moto', url: '/garantie-moto'},
                    {name: 'Assurance Temporaire', url: '/assurance-temporaire'},
                ],
                grossisteItems: [
                  {name: 'Garantie VP - VU - 4x4', url: '/garantie-autos'},
                  {name: 'Garantie Camping Car', url: '/garantie-camping-cars', style: 'disabled'},
                  {name: 'Garantie Moto', url: '/garantie-motos', style: 'disabled'},
                  {name: 'Assurance Temporaire', url: '/assurance-temporaire', style: 'disabled'},
                ],
                sagaItems: [
                  {name: 'Garantie VP - VU - 4x4', url: '/garantie-auto'},
                  {name: 'Garantie Camping Car', url: '/garanties-camping-car', style: 'disabled'},
                  {name: 'Garantie Moto', url: '/garanties-moto', style: 'disabled'},
                  {name: 'Assurance Temporaire', url: '/assurance-temporaire', style: 'disabled'},
                ],
                leMondeCampaignCarItems: [
                  {name: 'Garantie VP - VU - 4x4', url: '/garantie-autos', style: 'disabled'},
                  {name: 'Garantie Camping Car', url: '/garantie-camping-car',},
                  {name: 'Garantie Moto', url: '/garantie-motos', style: 'disabled'},
                  {name: 'Assurance Temporaire', url: '/assurance-temporaire', style: 'disabled'},
                ],
                brokerItems: [
                  {name: 'Assistance Autocars', url: '/assistance-autocars'},
                  {name: 'Assistance Poids Lourds', url: '/assistance-poids-lourds'},
                  {name: 'Assistance Taxi-Ambulance-VSL-Corbillard', url: '/assistance-vsl'},
                  {name: 'Assistance VP- VUL - 4097', url: '/assistance-vul4097'},
                  // {name: 'Assistance VU - VL', url: '/assistance-vu-vl'},
                ],
                Items4097: [
                  {name: 'Assistance VP- VUL - 4097', url: '/assistance-vul4097'},
                ],
                mutuaideItems: [
                  {name: 'Assistance Autocars', url: '/assistance-autocars'},
                  {name: 'Assistance Poids Lourds', url: '/assistance-poids-lourds'},
                  {name: 'Assistance Taxi-Ambulance-VSL-Corbillard', url: '/assistance-vsl'},
                  {name: 'Assistance VP- VUL - 4097', url: '/assistance-vul4097'},
                  // {name: 'Assistance VU - VL', url: '/assistance-vu-vl'},
                ],
                dealerItems: [
                  {name: 'Garantie Camping Car', url: '/garantie-camping-car-dealer'},
                  {name: 'MASTERS Assurance', url: '/devis-en-ligne-assurance'},
                ],
                gardenItems: [
                  {name: 'Garantie Outils de Jardin', url: '/garantie-outils-jardin'},
                ],
                representativeItems: [
                  {name: 'Importer des garanties', url: '/garantie-import'},
                ],
              mechanicTestItems: [
                {name: 'Garantie VP - VU - 4x4', url: '/garantie-auto'},
                {name: 'Garantie Camping Car', url: '/garantie-camping-car'},
                {name: 'Garantie Moto', url: '/garantie-moto'},
                {name: 'Assurance Temporaire', url: '/assurance-temporaire'},
                {name: 'Devis en ligne Assurance', url: '/devis-en-ligne-assurance'},
                {name: 'Panne Mécanique', url: '/panne-mecanique'},
              ],
                rechercheList: [
                    {name: 'Devis Garanties', url: '/devis'},
                    {name: 'Garanties souscrites', url: '/garantie-souscrites'},
                    {name: 'Clients', url: '/clients'},
                    {name: 'Statistiques avancées', url: '/stats'},
                ],
                rechercheDealerList: [
                    {name: 'Devis Garanties', url: '/devis'},
                    {name: 'Garanties souscrites', url: '/garantie-souscrites'},
                    {name: 'Devis Assurance', url: '/devis-insurances'},
                    {name: 'Assurances Souscrites', url: '/devis-insurances-souscrites'},
                    {name: 'Clients', url: '/clients'},
                    {name: 'Statistiques avancées', url: '/stats'},
                ],
              rechercheBrokerList: [
                {name: 'Devis Assistance', url: '/devis-assistance'},
                {name: 'Assistances souscrites', url: '/assistances-souscrite'},
                {name: 'Clients', url: '/clients-assistance'},
                {name: 'Statistiques avancées', url: '/stats-assistance'},
              ],
              rechercheMutuaideList: [
                {name: 'Devis Assistance', url: '/devis-assistance'},
                {name: 'Assistances souscrites', url: '/assistances-souscrite'},
                {name: 'Clients', url: '/clients-assistance'},
                {name: 'Statistiques avancées', url: '/stats-assistances'},
              ],
              representativeRecherchePreparedItems: [
                  {name: 'Garanties souscrites', url: '/garantie-souscrites'},
                  {name: 'Statistiques avancées', url: '/stats'},
              ],
              representativeMutuaideRecherchePreparedItems: [
                {name: 'Assistances souscrites', url: '/assistances-souscrites'},
              ],
              representativeSarrutRecherchePreparedItems: [
                {name: 'Devis Garanties', url: '/devis'},
                {name: 'Garanties souscrites', url: '/garantie-souscrites'},
                {name: 'Clients', url: '/clients'},
                {name: 'Statistiques avancées', url: '/stats'},
              ],
                activeTab: ''
            }
        },
        computed: {
            menuItems() {
                if (this.$store.getters.isRepresentative && this.$store.getters.isSarrutAdmin) {
                  return this.grossisteItems;
                }
                else if (this.$store.getters.isRepresentative && this.$store.getters.isSagaAdmin) {
                  return this.sagaItems;
                }
                else if (this.$store.getters.isRepresentative) {
                  return this.representativeItems;
                }
                else if (this.$store.getters.isSarrut) {
                  return this.grossisteItems;
                }
                else if (this.$store.getters.isSaga) {
                  return this.sagaItems;
                }
                else if (this.$store.getters.isLeMondeCampingCar) {
                  return this.leMondeCampaignCarItems;
                }
                else if (this.$store.getters.isBroker) {
                  return this.brokerItems;
                }
                else if (this.$store.getters.is4097) {
                  return this.Items4097;
                }
                else if (this.$store.getters.isMutuaide) {
                  return this.mutuaideItems;
                }
                else if (this.$store.getters.isGarden) {
                  return this.gardenItems;
                }
                else if (this.$store.getters.isDealer || (+this.$store.getters.getMechanic.id === 3909)) {
                  return this.dealerItems;
                }
                else if (this.$store.getters.getMechanic.id === 325 || this.$store.getters.getMechanic.id === 321) {
                  return this.mechanicTestItems;
                }
                else {
                  return this.mechanicItems;
                }
            },
            recherchePreparedList() {
              if (this.$store.getters.isRepresentative && (this.$store.getters.getRepresentative.owner_type == 3)) {
                return this.representativeMutuaideRecherchePreparedItems;
              }
              else if (this.$store.getters.isRepresentative && (this.$store.getters.getRepresentative.id == 58 || this.$store.getters.getRepresentative.id == 61)) {
                return this.representativeSarrutRecherchePreparedItems;
              }
              else if (this.$store.getters.isRepresentative) {
                return this.representativeRecherchePreparedItems;
              }
              else if (this.$store.getters.isDealer) {
                return this.rechercheDealerList;
              }
              else if (this.$store.getters.isBroker) {
                return this.rechercheBrokerList;
              }
              else if (this.$store.getters.isMutuaide) {
                return this.rechercheMutuaideList;
              }
              else {
                return this.rechercheList;
              }
            },
          isGUEMASrepresentative() {
            return this.$store.getters.isRepresentative && (this.$store.getters.getRepresentative.id == 12);
          },
          isMutuaiderepresentative() {
            return this.$store.getters.isRepresentative && (this.$store.getters.getRepresentative.owner_type == 3);
          },
          isMutuaidecommercial() {
            return this.$store.getters.isRepresentative && (this.$store.getters.getRepresentative.id == 15);
          },
          isMutuaide() {
            return this.$store.getters.isMutuaide;
          },
          isSarrut() {
            return this.$store.getters.isSarrut;
          },
          isSarrutAdmin() {
            return this.$store.getters.isSarrutAdmin;
          },
          isSaga() {
            return this.$store.getters.isSaga;
          },
          isSagaAdmin() {
            return this.$store.getters.isSagaAdmin;
          },
          isLeMondeCampingCar() {
            return this.$store.getters.isLeMondeCampingCar;
          },
        },
        methods: {
            setActiveTab(tabName) {
                this.activeTab = tabName;
            },
            exportParc() {
              let url;
              if (this.$store.getters.getRepresentative.id != 13) {
                let representative_id = this.$store.getters.getRepresentative.id;
                url = 'mutuaide/export/parc_rep/'+representative_id;
              }
              else
                url = 'mutuaide/export/parc';
              window.location = this.getApiAuthUrl(url);
            },
            exportParcComplete() {
              let url
              if (this.$store.getters.getRepresentative.id != 13) {
                let representative_id = this.$store.getters.getRepresentative.id;
                url = 'mutuaide/export/parc_complete_rep/'+representative_id;
              }
              else
                url = 'mutuaide/export/parc_complete';
              window.location = this.getApiAuthUrl(url);
            }
        },
        mounted() {
            this.$eventBus.$on('sidebar-set-active-tab', this.setActiveTab);
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Sidebar.vue